import { render, staticRenderFns } from "./department.vue?vue&type=template&id=28f22b11&scoped=true&"
import script from "./department.vue?vue&type=script&lang=js&"
export * from "./department.vue?vue&type=script&lang=js&"
import style0 from "./department.vue?vue&type=style&index=0&id=28f22b11&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f22b11",
  null
  
)

export default component.exports